import type { TravelBooking } from './queries';

/**
 * La política de autos y traslados se pide automáticamente cuando ya hay hold y
 * todavía se puede decidir no confirmar. Solo con capacidad explícita: no se
 * prueba a ciegas ni se repite una consulta de la misma reserva.
 */
export function shouldPreloadBookingCancellationPolicy({
  vertical,
  state,
  hasRemoteBooking,
  verdict,
  asked,
}: {
  vertical: TravelBooking['vertical'] | undefined;
  state: TravelBooking['state'] | undefined;
  hasRemoteBooking: boolean;
  verdict: 'supported' | 'unsupported' | 'unknown';
  asked: boolean;
}): boolean {
  return (
    (vertical === 'transfers' || vertical === 'cars') &&
    (state === 'draft' || state === 'held') &&
    hasRemoteBooking &&
    verdict === 'supported' &&
    !asked
  );
}
